module.exports = __webpack_public_path__ + "static/media/kitty.e196b333.mp3";